import { 
  useGetTeachersQuery, 
  useGetReadersQuery, 
  useGetUsersByCourseIdQuery, 
  useGetUsersByGroupIdQuery 
} from '../usersApi';

export const useTeachers = (params = {}) => {
  return useGetTeachersQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      teachers: data || [],
      isLoading,
      isError,
      error,
    }),
  });
};

export const useReaders = (params = {}, options = {}) => {
  return useGetReadersQuery(params, {
    ...options,
    selectFromResult: ({ data, isLoading, isFetching, isError, error }) => ({
      readers: data || [],
      isLoading,
      isFetching,
      isError,
      error,
    }),
  });
};

export const useUsersByCourseId = (params = {}) => {
  return useGetUsersByCourseIdQuery(params, {
    skip: !params.courseId,
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      users: data || [],
      isLoading,
      isError,
      error,
    }),
  });
};

export const useUsersByGroupId = (params = {}) => {
  return useGetUsersByGroupIdQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      users: data || [],
      isLoading,
      isError,
      error,
    }),
    skip: !params.circleId,
  });
};

